import type { ZEPLogger } from '@zep/logger';

function getGPUInfo(): Record<string, string> {
  try {
    if (typeof document === 'undefined') return {};
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl');
    if (!gl) {
      return { zep_gpu_renderer: 'none', zep_webgl_available: 'false' };
    }
    const ext = gl.getExtension('WEBGL_debug_renderer_info');
    return {
      zep_gpu_renderer: ext
        ? gl.getParameter(ext.UNMASKED_RENDERER_WEBGL)
        : 'unknown',
      zep_webgl_available: 'true',
    };
  } catch {
    return { zep_gpu_renderer: 'error', zep_webgl_available: 'error' };
  }
}

async function getPlatformInfo(): Promise<Record<string, string>> {
  try {
    const uaData = (
      navigator as Navigator & {
        userAgentData?: {
          getHighEntropyValues?: (
            hints: string[],
          ) => Promise<Record<string, string>>;
        };
      }
    )?.userAgentData;
    if (!uaData?.getHighEntropyValues) {
      return {
        zep_cpu_architecture: 'unsupported',
        zep_platform_version: 'unsupported',
      };
    }
    const ua = await uaData.getHighEntropyValues([
      'architecture',
      'platformVersion',
    ]);
    return {
      zep_cpu_architecture: ua.architecture ?? 'unknown',
      zep_platform_version: ua.platformVersion ?? 'unknown',
    };
  } catch {
    return {
      zep_cpu_architecture: 'error',
      zep_platform_version: 'error',
    };
  }
}

export function getGPUInfoState(): Record<string, string> {
  return getGPUInfo();
}

export function hydratePlatformInfo(logger: ZEPLogger): void {
  if (typeof window === 'undefined') return;
  getPlatformInfo().then(info => {
    logger.setState(info);
  });
}
